<template>
  <div
    id="email-criteria-form"
  >
    <fieldset>
      <legend>Email User Criteria</legend>

      <div
        class="form-group row"
      >
        <span
          class="col"
        >
          <label
            for="email_criteria_purchase_start_at"
          >
            Purchased After
          </label>

          <input
            type="date"
            class="form-control"
            :name="inputName('purchase[start_at]')"
            :value="criteria['purchase']['start_at']"
            id="email_criteria_purchase_start_at"
          />
        </span>
        <span
          class="col"
        >
          <label
            for="email_criteria_purchase_end_at"
          >
            Purchased Before
          </label>

          <input
            type="date"
            class="form-control"
            :name="inputName('purchase[end_at]')"
            :value="criteria['purchase']['end_at']"
            id="email_criteria_purchase_end_at"
          />
        </span>
      </div>

      <div
        class="form-group"
      >
        <purchasable-item-select
          ref="purchasableItemSelect"
          :selectId="selectName"
          :selectName="selectName"
          :selected="criteria.purchasable_items"
          multiple
          allowSearch
        />
      </div>

      <!-- // Tag handling is being deprecated
      <div
        class="form-group"
      >
        <label
          :for="tagSelectName"
        >
          Select Tags
        </label>

        <p
          class="alert alert-warning text-center"
        >
          Please note that there are separate tags for Inkubator purchases and Inkubator Backer purchases.
        </p>

        <tag-select
          ref="tagSelect"
          :type="tagSelectName"
          :selectedTagIds="criteria.purchase.tags"
          noButtons
          noHeader
        />
      </div>
      -->
    </fieldset>
  </div>
</template>
<script>
import PurchasableItemSelect from '@/components/PurchasableItemSelect'
import TagSelect from '@/components/TagSelect'

export default {
  data () {
    return {
      selected_purchasable_items: []
    }
  },

  props: {
    criteria: {
      type: Object,
      default: () => {
        return {
          purchase: {},
          purchasable_items: []
        }
      }
    },

    modelName: {
      type: String,
      default: 'targeted_email'
    }
  },

  computed: {
    selectName () {
      return this.modelName + '[criteria][purchasable_items][]'
    },

    tagSelectName () {
      return this.modelName + '[criteria][purchase[tags][]'
    },

    selectedItems () {
      if (this.$refs.purchasableItemSelect) {
        const pids = this.criteria.purchasable_items.map(item => Number.parseInt(item))
        return this.$refs.purchasableItemSelect.filter(item => pids.include(item))
      }
    },

    selectedTags () {
      if (this.$refs.tagSelect) {
        const tids = this.criteria.tags.map(item => Number.parseInt(item))
        return this.$refs.tagSelect.filter(item => tids.include(item))
      }
    }
  },

  components: {
    'purchasable-item-select': PurchasableItemSelect,
    'tag-select': TagSelect
  },

  methods: {
    inputName (name) {
      return `${this.modelName}[criteria][${name}]`
    },

    setSelectedCriteriaItems () {
      this.selected_purchasable_items = this.$refs.purchasableItemSelect.filteredPurchasableItems
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailCriteriaForm.vue